// src/EducationIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var EducationIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "currentColor",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_351_1253)", children: /* @__PURE__ */ jsx("path", { d: "M19.5105 5.41995L10.1906 0.779062C10.1217 0.718378 10.0334 0.684937 9.942 0.684937C9.8506 0.684937 9.76229 0.718378 9.69345 0.779062L0.373535 5.41995C0.123565 5.41995 0 5.67077 0 5.92159C0 6.17241 0.123565 6.42323 0.373535 6.42323L9.69345 11.0627C9.81844 11.0627 9.81844 11.1888 9.942 11.1888C10.0656 11.1888 10.0656 11.1888 10.1906 11.0627L17.5221 7.42651V12.6937C17.5221 13.0692 17.772 13.3201 18.1442 13.3201C18.5177 13.3201 18.7648 13.0692 18.7648 12.6937V6.79874L19.5105 6.42323C19.7604 6.42323 19.884 6.17241 19.884 5.92159C19.884 5.67077 19.7604 5.41995 19.5105 5.41995ZM9.942 9.80858L1.9884 5.92159L9.942 2.03316L17.8956 5.92159L9.942 9.80858ZM15.4101 9.23958C15.7822 9.23958 16.0322 9.4904 16.0322 9.86591V15.6462C16.0322 15.7709 15.9072 16.0217 15.6587 16.1479C13.8637 16.9731 11.9144 17.4008 9.942 17.402C7.83004 17.402 5.84022 17.025 4.22535 16.1479C3.9768 16.1479 3.85182 15.8971 3.85182 15.6462V9.86591C3.85182 9.4904 4.10179 9.23958 4.4739 9.23958C4.84744 9.23958 5.09457 9.4904 5.09457 9.86591V15.2693C7.83004 16.5234 12.054 16.5234 14.7894 15.2693V9.86591C14.7894 9.4904 15.0366 9.23958 15.4101 9.23958Z" }) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_351_1253", children: /* @__PURE__ */ jsx(
        "rect",
        {
          width: "20",
          height: "20.1826",
          fill: "currentColor",
          transform: "translate(0 0.684937)"
        }
      ) }) })
    ]
  }
);
var EducationIcon_default = EducationIcon;

export {
  EducationIcon_default
};
